module.exports = __webpack_public_path__ + "public/images/slider/speaker-3.6823d7c07daac5446d8261c2a8b4f63c.jpg";